import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class SessionService {

  idleDetector: Subject<boolean>;

  constructor() {
    this.idleDetector = new Subject();
  }

  resetTimer() {
  }
}
